module.exports = __webpack_public_path__ + "img/CD.edad9536.png";